import { IExcelRow, IPropertyMapping, IPropertyUpdate } from '@/typings/import';

export default class PropertyUpdateHelper {

  static getNewValueAsPropertyValue<T>(propertyUpdate: IPropertyUpdate<any>): T {
    return propertyUpdate.newValue as unknown as T;
  } 

  static getNewValueFromMapping(propertyMapping: IPropertyMapping, row: IExcelRow) {
    if (propertyMapping.useStatic) {
      return propertyMapping.static;
    }
    if (propertyMapping.cell) {
      return row.excelRowData[propertyMapping.cell];
    }
    return null;
  }

  static propertyMappingIsDefined(propertyMapping: IPropertyMapping) {
    if (propertyMapping.useStatic) {
      return propertyMapping.static !== null && propertyMapping.static !== undefined;
    }
    return !!propertyMapping.cell;
  }

  /**
   * Returns propertyupdates set value, if no value is set, gives default value.
   */
  static getValue(propertyUpdate: IPropertyUpdate<any>) {
    let value = propertyUpdate.doNotUpdate 
    ? propertyUpdate.oldValue : propertyUpdate.overrideValue 
    ? propertyUpdate.overrideValue : propertyUpdate.newValue;
    
    if (value !== null && value !== undefined) {
      switch (propertyUpdate.propertyType) {
        case 'number':
        case 'number | null':
          return parseFloat(value as unknown as string) as any;
        case 'string | null':
        case 'string':
          return (value as unknown as string).trim();
        case 'boolean':
          if (typeof(value) === 'string') {
            switch (value as unknown as string) {
              case 'true':
                value = true as any;
                break;
              case 'false':
                value = false as any;
                break;
              default:
                value = (value as unknown as string).trim() ? true as any : false as any
                break;
            }
          }
          return value as any;
        default:
          return value as any;
      }      
    }

    // Exceptions to regular type rules
    // TODO: It might be better to define default value in property mapping and apply that to property update
    switch (propertyUpdate.propertyName) {
      case 'billingUseHomeAddress':
        return true;
      default:
        break;
    }
    // Regular type default values
    switch (propertyUpdate.propertyType) {
      case 'number':
        return 0;
      case 'number | null':
      case 'string | null':
        return null;
      case 'string':
        return '';
      case 'boolean':
        return false;
      default:
        return undefined;
    }
  }
}
